import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { RequirementField } from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.interface';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { tap, takeUntil } from 'rxjs/operators';
import { LocaleSettingService } from 'app/services/i18n/locale-setting.service';

@Component({
    selector: 'ba-currency',
    templateUrl: 'currency-attribute.component.html'
})

export class CurrencyAttributeComponent implements OnInit, OnDestroy {

    @Input() field: RequirementField;
    @Input() form: UntypedFormGroup;
    @Input() disabled: boolean;

    numberMaskPrefix = '';
    mask = '';
    destroyed$ = new Subject<void>();

    constructor(private localeSettingService: LocaleSettingService) {
        this.numberMaskPrefix = this.localeSettingService.getLocaleCurrencySymbol() + ' ';
        this.mask = createNumberMask({
            prefix: this.numberMaskPrefix, // This will put the currency sign at the beginning, with a space.
            suffix: '',
            allowDecimal: true
        });
    }

    ngOnInit() {
        this.control.valueChanges.pipe(
            takeUntil(this.destroyed$),
            tap((value: string = '') => {
                const unmaskedValue = value.replace(/[^\d.+]/g, '');
                this.control.setValue(unmaskedValue, { emitEvent: false, emitModelToViewChange: false });
            }),
        ).subscribe();
    }

    ngOnDestroy() {
        this.destroyed$.next();
    }

    get control() {
        return this.form.controls[this.field.alias];
    }
}
